import '@app/App.css';
import HomeHeader from '@app/HomeHeader';
import { useEffect, useState } from 'react';
import { useUserStore } from 'src/store';
import { TW_App } from '@utils/twClasses';
import { articleComponentsByLang } from './content';

function Manual() {

  const lang = useUserStore((state) => state.lang) || 'fr';
  const articlesFr = [
    {
      slug: 'introduction',
      title: 'Bienvenue dans Compozz !'
    },
    {
      slug: 'comment-creer-votre-modele-de-donnees',
      title: 'Les espaces de travail'
    },
    {
      slug: 'les-differents-types-de-champs',
      title: 'Les différents types de champs'
    },
    {
      slug: 'formules',
      title: 'Les formules'
    },
    {
      slug: 'vues',
      title: 'Les vues'
    },
    {
      slug: 'comment-exporter-et-importer-un-modele-de-donnees',
      title: 'Exporter et importer un modèle de données'
    },
    {
      slug: 'comment-importer-vos-donnees-dans-compozz',
      title: 'Importez des données'
    },

    {
      slug: 'comment-creer-des-tableaux-de-bord',
      title: 'Les tableaux de bord'
    },
    {
      slug: 'gestion-droit-utilisateur',
      title: 'Les droits d\'accès'
    },
    {
      slug: 'comment-automatiser-vos-taches-avec-make',
      title: 'Automatisation avec Make'
    },
    {
      slug: 'automatisez-vos-taches-avec-n8n',
      title: 'Automatisation avec n8n'
    },
  ];

  const articlesEn = [
    {
      slug: 'introduction',
      title: 'Welcome to Compozz!'
    },
    {
      slug: 'comment-creer-votre-modele-de-donnees',
      title: 'Data models'
    },   
    {
      slug: 'les-differents-types-de-champs',
      title: 'The different types of fields'
    },
    {
      slug: 'formules',
      title: 'Formulas'
    },
    {
      slug: 'vues',
      title: 'Views'
    },
    {
      slug: 'comment-exporter-et-importer-un-modele-de-donnees',
      title: 'Export and import a data model'
    },
    {
      slug: 'comment-importer-vos-donnees-dans-compozz',
      title: 'Import data'
    },
    {
      slug: 'comment-creer-des-tableaux-de-bord',
      title: 'Dashboards'
    },
    {
      slug: 'gestion-droit-utilisateur',
      title: 'Users access rights'
    },
    {
      slug: 'comment-automatiser-vos-taches-avec-make',
      title: 'Automation with Make'
    },
    {
      slug: 'automatisez-vos-taches-avec-n8n',
      title: 'Automation with n8n'
    },
  ];

  const articles = lang === 'en-EN' ? articlesEn : articlesFr;
  const langKey = (lang === 'en-EN' ? 'en' : 'fr') as 'fr' | 'en';

  const [selected, setSelected] = useState<string | null>(null);

  useEffect(() => {
    if (articles.length > 0 && !selected) {
      setSelected(articles[0].slug);
    }
  }, [articles, selected]);

  const Comp = selected ? (articleComponentsByLang[langKey]?.[selected] ?? null) : null;

  return (
    <div className={TW_App}>
      <HomeHeader />
      <div className="flex flex-row w-full flex-1 p-4 gap-4 overflow-hidden">
        <div className="w-64 min-w-64 max-w-64 h-full overflow-y-auto scrollbar-thin scrollbar-thumb-compozz-purple scrollbar-track-compozz-purple-light scrollbar-button-hidden border-1 border-gray-200 rounded-md p-2 bg-white">
          <h2 className="text-sm text-gray-500 mb-2">Manuel utilisateur</h2>
          <ul className="flex flex-col gap-1">
            {articles.map((article) => (
              <li key={article.slug}>
                <button
                  className={`w-full text-left text-sm px-2 py-1 rounded-md ${
                    selected === article.slug ? 'bg-gray-100 font-bold' : 'hover:bg-gray-50'
                  }`}
                  onClick={() => setSelected(article.slug)}
                >
                  {article.title}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex-1 h-full overflow-y-auto scrollbar-thin scrollbar-thumb-compozz-purple scrollbar-track-compozz-purple-light scrollbar-button-hidden border-1 border-gray-200 rounded-md p-4 bg-white relative">
          <div className="manual-pane">
            {!Comp && <p className="text-sm text-gray-500">Sélectionnez un article.</p>}
            {Comp && (
                <Comp />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Manual;


